import { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import Layout from "../../../components/dashboard/Layout";
import AddPDF from "../../../containers/superadmin/pdfs/models/add-lecture";
import SearchBar from "../../../containers/superadmin/pdfs/searchbar";
import PDFTable from "../../../containers/superadmin/pdfs/table";
import {
  getAllPdfsRequest,
  getCoursePdfRequest,
} from "../../../modules/superadmin-modules/lectures/Actions";
const SuperadminPdfs = () => {
  const [isAdd, setAdd] = useState(false);
  const [selectedData, setSelectedData] = useState({});
  const dispatch = useDispatch();
  const [courseId, setCourseId] = useState(null);

  useEffect(() => {
    if (courseId) {
      dispatch(getCoursePdfRequest(courseId));
    } else {
      dispatch(getAllPdfsRequest());
    }
  }, [courseId]);

  return (
    <Layout>
      <SearchBar setAdd={setAdd} setCourseId={setCourseId} />
      <PDFTable setAdd={setAdd} setSelectedData={setSelectedData} />
      <AddPDF
        isAdd={isAdd}
        data={selectedData}
        setSelectedData={setSelectedData}
      />
    </Layout>
  );
};

export default SuperadminPdfs;
